export default __webpack_public_path__ + "static/media/hydraulica-logo-white.c03d09a1.png";